module.exports = __webpack_public_path__ + "static/media/horoscope-icon-1.fe054b77.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-1.png
// module id = 1525
// module chunks = 0